export default {
    user: JSON.parse(window.localStorage.getItem("user")),
    contrato: null,
    cliente: null,
    ponto: null,
    smtp: null,
    repetidor: null,
    plano_internet: null
};
